module.exports = __webpack_public_path__ + "static/media/program_category_black_fade2.f51dd7ba.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/utils/program_category_black_fade2.png
// module id = 125
// module chunks = 0